import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { NONE_NAME } from 'src/Utils/globalConstants'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from './DashboardDimensionFilterDropdowns/DashboardDimensionFilterDropdown'

// Vendor values come from the vendors dim stamped on the risk metrics.
export const DashboardVendorFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null => {
  if (dashboardContext === undefined || dashboardName === undefined) {
    return null
  }

  return (
    <DashboardDimensionFilterDropdown
      isNested={isNested}
      filterParam={FilterParam.DASHBOARD_VENDOR}
      filterName={FilterName.DASHBOARD_VENDOR}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="vendors"
      // Points carrying no vendors dim land in this bucket.
      undefinedString={NONE_NAME}
    />
  )
}
